function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '')
}

function defaultApiBaseUrl(): string {
  if (import.meta.env.DEV) {
    return `http://localhost:8000`
  }
  return ''
}

function defaultWsBaseUrl(): string {
  if (import.meta.env.DEV) {
    return `ws://localhost:8000`
  }
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${protocol}//${window.location.host}`
}

export const API_BASE_URL = trimTrailingSlash(import.meta.env.VITE_API_BASE_URL?.trim() || defaultApiBaseUrl())
export const WS_BASE_URL = trimTrailingSlash(import.meta.env.VITE_WS_BASE_URL?.trim() || defaultWsBaseUrl())
